import React from "react";
import styles from "./cartBtn.scss";
import PropTypes from "prop-types";
import NewSpinner from "../newSpinner/newSpinner";

function CartBtn({
  isOutOfStock,
  onAddToCart,
  cartText,
  displayCartIcon,
  disableAddToCart,
  isLoading,
  spinnerBackground,
}) {
  const handleAddToCart = () => {
    if (disableAddToCart || isOutOfStock) {
      return;
    }
    onAddToCart();
  };

  const bk = disableAddToCart || isOutOfStock ? "#949494" : null;
  return (
    <div className={styles["common-btn-container"]}>
      <div
        className={styles["common-btn"]}
        onClick={handleAddToCart}
        style={
          isLoading
            ? { background: spinnerBackground, padding: "10px 8px" }
            : { background: bk }
        }
      >
        {isLoading ? (
          <NewSpinner size="sm" />
        ) : (
          <>
            {displayCartIcon && (
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.0787 13.3396C15.0787 14.3263 14.2966 15.1262 13.3318 15.1262C12.367 15.1262 11.5849 14.3263 11.5849 13.3396V13.3377C11.5849 13.0739 11.6899 12.6745 11.8192 12.4463H7.85678C7.98612 12.6745 8.09106 13.0739 8.09106 13.3377V13.3396C8.09106 14.3263 7.30893 15.1262 6.34415 15.1262C5.37937 15.1262 4.59724 14.3263 4.59724 13.3396C4.59724 12.8595 4.78273 12.424 5.08402 12.103L3.18443 2.17329H0.994233C0.813347 2.17329 0.666687 2.0233 0.666687 1.8383V1.16833C0.666687 0.983329 0.813347 0.833336 0.994233 0.833336H3.72378C4.03707 0.833336 4.30653 1.06023 4.36669 1.37467L4.60489 2.61995H15.7336C16.1514 2.61995 16.4625 3.01464 16.3737 3.43223L15.1395 9.23872C15.074 9.54672 14.8075 9.76639 14.4994 9.76639H5.97211L6.22841 11.1063H13.9298C14.3477 11.1063 14.6587 11.5011 14.5699 11.9187L14.5417 12.0515C14.8725 12.3766 15.0787 12.8333 15.0787 13.3396ZM5.71581 8.42648H13.9716L14.9209 3.95995H4.86118L5.71581 8.42648ZM6.34415 14.0096C5.98291 14.0096 5.68906 13.7091 5.68906 13.3397C5.68906 12.9702 5.98291 12.6697 6.34415 12.6697C6.70539 12.6697 6.99924 12.9702 6.99924 13.3397C6.99924 13.7091 6.70539 14.0096 6.34415 14.0096ZM12.6767 13.3397C12.6767 13.7091 12.9706 14.0096 13.3318 14.0096C13.693 14.0096 13.9869 13.7091 13.9869 13.3397C13.9869 12.9702 13.693 12.6697 13.3318 12.6697C12.9706 12.6697 12.6767 12.9702 12.6767 13.3397Z"
                  fill="white"
                />
              </svg>
            )}
            {cartText && <span>{cartText}</span>}
          </>
        )}
      </div>
    </div>
  );
}
CartBtn.defaultProps = {
  isOutOfStock: false,
  displayCartIcon: true,
  cartText: "",
  spinnerBackground: "#707070",
};
CartBtn.propTypes = {
  isOutOfStock: PropTypes.bool,
  displayCartIcon: PropTypes.bool,
  cartText: PropTypes.string,
};

export default CartBtn;
